import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';

import { API_URL } from '@constants';
import { Activity } from '@models';

@Service()
export class ActivitiesService {
  http = inject(HttpClient);

  getActivitiesByAuthor = (params: string) =>
    this.http.get<Activity[]>(`${API_URL}/activities/author${params}`);

  getActivitiesByExecutor = (params: string) =>
    this.http.get<Activity[]>(`${API_URL}/activities/executor${params}`);

  getActivity = (rid: number) =>
    this.http.get<Activity>(`${API_URL}/activities/${rid}`);

  updateActivityStatus = (
    rid: number,
    statusData: { status: number; updateDate?: number }
  ) =>
    this.http.post<Activity>(`${API_URL}/activities/${rid}/status`, statusData);

  updateActivity = (rid: number, activityData: Partial<Activity>) =>
    this.http.put<Activity>(`${API_URL}/activities/${rid}`, activityData);

  getActivitiesByResource = (pathType: string, rid: number) =>
    this.http.get<Activity[]>(`${API_URL}/${pathType}/${rid}/activities`);
}
